/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { CustomIvr } from './CustomIvr';
import {
  CustomIvrFromJSON,
  CustomIvrFromJSONTyped,
  CustomIvrToJSON,
} from './CustomIvr';

/**
 *
 * @export
 * @interface Ivr
 */
export interface Ivr {
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  ivrType: string;
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  text?: string;
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  mp3?: string;
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Ivr
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof Ivr
   */
  selectedCustomIvrDetails?: number;
  /**
   *
   * @type {Array<CustomIvr>}
   * @memberof Ivr
   */
  customIvrs?: Array<CustomIvr>;
}

/**
 * Check if a given object implements the Ivr interface.
 */
export function instanceOfIvr(value: object): value is Ivr {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('ivrType' in value) || value['ivrType'] === undefined) return false;
  return true;
}

export function IvrFromJSON(json: any): Ivr {
  return IvrFromJSONTyped(json, false);
}

export function IvrFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ivr {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    ivrType: json['ivr_type'],
    text: json['text'] == null ? undefined : json['text'],
    mp3: json['mp3'] == null ? undefined : json['mp3'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    selectedCustomIvrDetails:
      json['selected_custom_ivr_details'] == null
        ? undefined
        : json['selected_custom_ivr_details'],
    customIvrs:
      json['custom_ivrs'] == null
        ? undefined
        : (json['custom_ivrs'] as Array<any>).map(CustomIvrFromJSON),
  };
}

export function IvrToJSON(value?: Ivr | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    ivr_type: value['ivrType'],
    text: value['text'],
    mp3: value['mp3'],
    name: value['name'],
    description: value['description'],
    selected_custom_ivr_details: value['selectedCustomIvrDetails'],
    custom_ivrs:
      value['customIvrs'] == null
        ? undefined
        : (value['customIvrs'] as Array<any>).map(CustomIvrToJSON),
  };
}
